var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0 pt-5"},_vm._l((_vm.filters),function(filter,idx){return _c('v-row',{key:idx,attrs:{"no-gutters":""}},[_c('sidebar-switcher-filter',_vm._b({},'sidebar-switcher-filter',filter,false))],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }